import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCookiePreferences } from '../../store/slices/authSlice';
import { trackEvent, ANALYTICS_EVENTS } from '../../utils/analytics';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { cookiePreferences } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    // Show banner if preferences haven't been set
    if (!cookiePreferences) {
      setIsVisible(true);
    }
  }, [cookiePreferences]);

  const handleAcceptAll = () => {
    dispatch(setCookiePreferences({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    }));
    trackEvent(ANALYTICS_EVENTS.COOKIE_CONSENT, {
      consent_type: 'all'
    });
    if (window.fbq) {
      window.fbq('consent', 'grant');
    }
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    dispatch(setCookiePreferences({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    }));
    trackEvent(ANALYTICS_EVENTS.COOKIE_CONSENT, {
      consent_type: 'necessary_only'
    });
    if (window.fbq) {
      window.fbq('consent', 'revoke');
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t p-4 z-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-600">
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
              <a href="/privacy-policy" className="text-blue-600 hover:underline ml-1">
                Learn more
              </a>
            </p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleAcceptNecessary}
              className="px-4 py-2 text-sm text-gray-600 border rounded hover:bg-gray-50"
            >
              Necessary Only
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 